import { render, staticRenderFns } from "./workDetail.vue?vue&type=template&id=743dc5ee&scoped=true&"
import script from "./workDetail.vue?vue&type=script&lang=js&"
export * from "./workDetail.vue?vue&type=script&lang=js&"
import style0 from "./workDetail.vue?vue&type=style&index=0&id=743dc5ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743dc5ee",
  null
  
)

export default component.exports